import axios from "axios";
import React from "react";
import 'bootstrap/dist/css/bootstrap.css';
import UploadGalleryImage from "../components/UploadGalleryImage";
import Chatbutton from '../components/chatbutton'
import '../styles/chatbutton.css'
import '../styles/GalleryScreen.css'


export default class GalleryScreen extends React.Component {
 state = {
  posts: []
 }

 componentDidMount() {
  axios.get(`https://shoppee-clone.herokuapp.com/gallery`)
 .then(res => {
    const posts = res.data;
    this.setState({ posts });
   })
 }

 render() {
  return (
 
  <div>
    <UploadGalleryImage></UploadGalleryImage>
    { this.state.posts.map(post =>
      <div className="card container-fluid" id="cardproduct"><br/>
        <div className="img-card"><img className="w-100 h-custom rounded" src={'images/'+post.image}/></div>
      </div>)}
      <Chatbutton ></Chatbutton>
   </div>
   
  )
 }
}